<template>

  <div class="containers">
    <el-image  :src="displayUrl"
               :zoom-rate="1.2"
               :max-scale="7"
               :min-scale="0.2"
               :preview-src-list="displayUrlList"
               show-progress
               :initial-index="index"
               :z-index="999"
               fit="cover"
               @error="judgeError"
    >

      <template #error v-if="isError">
        <div class="image-slot">
          <el-icon><Picture /></el-icon>
        </div>
      </template>
    </el-image>
  </div>
</template>
<script >
import {ElIcon,ElImage} from "element-plus";
import heic2any  from 'heic2any';
export default {
  components:{
    ElIcon,ElImage
  },
  name: 'myImageIcon',
  data(){
    return {
      isError:false,
      displayUrl:"",
      displayUrlList:[],
    }
  },
  props:{
    pictureUrl:{
      type:String,
      required:true
    },
    pictureUrlList:{
      type:Array,
    },
    index:{
      default:0,
      type:Number
    }
  },
  mounted() {
    console.log('Component mounted.')
  },
  beforeMount() {
    if (this.displayUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.displayUrl)
    }
  },
  watch: {
    pictureUrl: {
      immediate: true,
      async handler(newUrl) {

        if (!newUrl || newUrl === null ){
          return
        }
        try {
          if (newUrl.toLowerCase().endsWith('.heic')) {
            const response = await fetch(newUrl)
            const blob = await response.blob()
            const jpegBlob = await heic2any({
              blob,
              toType: 'image/jpeg',
              quality: 0.8
            })
            this.displayUrl = URL.createObjectURL(jpegBlob)
          } else {
            this.displayUrl = newUrl
          }
        } catch (e) {
          console.error('HEIC转换失败:', e)
          this.displayUrl = this.fallback
        } finally {
          this.isError=true
        }
      }
    },
    pictureUrlList: {
      immediate: true,
      async handler(newUrlList) {
        if (newUrlList.length==0) return
        this.displayUrlList = []
        for (let i = 0; i < newUrlList.length; i++) {
          if (!newUrlList[i] || newUrlList[i] === null ){
            return
          }
          try {
            if (newUrlList[i].toLowerCase().endsWith('.heic')) {
              const response = await fetch(newUrlList[i])
              const blob = await response.blob()
              const jpegBlob = await heic2any({
                blob,
                toType: 'image/jpeg',
                quality: 0.8
              })
              this.displayUrlList.push(URL.createObjectURL(jpegBlob))
            } else {
              this.displayUrlList.push(newUrlList[i])
            }
          } catch (e) {
            console.error('HEIC转换失败:', e)
          } finally {
            this.isError=true
          }
        }
      }
    }
  },
  methods:{
    judgeError(){
        this.isError=true
    },
  },

}
</script>
<style scoped>
.containers{
  width: 150px;
  height: 150px;
}
.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
  border: 1px #999999 dashed;
}
.block {
  padding: 30px 0;
  text-align: center;
  border-right: solid 1px var(--el-border-color);
  display: inline-block;
  width: 49%;
  box-sizing: border-box;
  vertical-align: top;
}
.demonstration {
  display: block;
  color: var(--el-text-color-secondary);
  font-size: 14px;
  margin-bottom: 20px;
}
.el-image {
  padding: 0 ;
  max-width: 300px;
  max-height: 200px;
  width: 100%;
  height: 100%;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}
.image-slot .el-icon {
  font-size: 30px;
}

</style>